{
  "sign_up": "Sign up to get started",
  "signUp": "Sign up",
  "haveAccount": "Already have an account?",
  "signIn": "Sign in",
  "firstName": "First Name",
  "lastName": "Last Name",
  "password": "Password",
  "passwordConfirm": "Confirm password",
  "8char": "8 characters minimum",
  "oneNumber": "One number",
  "oneLower": "One lowercase character",
  "oneUpper": "One uppercase character",
  "toggle_1": "Otakus may use my contact data to keep me informed of products, services and offerings.",
  "toggle_2": "I accept the product Terms and conditions of this registration form.",
  "passwordNotTheSame": "Passwords are not the same",
  "fieldRequired": "Field is required",
  "sign_up_done": "Sign up successful",
  "check_email": "We have send you an e-mail, check it to complete your registration.",
  "to_join": "Sign up to join",
  "email": "Email"
}
